import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import { LABELS as DEFAULT_LABELS, INTERNATIONAL_FUNNELS, FUNNELS } from '../../util/constants';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { formatDecimal } from '../../util/format-decimal';
import { Stack } from '@nib/layout';
import Copy from '@nib-components/copy';
import { defaultFieldPropTypes } from '../../types';
import { StandardInfoBox } from '../info-box';
const LABELS = {
  ARHI: DEFAULT_LABELS.PAYMENT_FREQUENCY
};
const HELP_TEXTS = {
  ARHI: 'How often would you like to make payments?'
};
const PaymentFrequency = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    options = {
      Weekly: 'Weekly',
      Fortnightly: 'Fortnightly',
      Monthly: 'Monthly',
      Quarterly: 'Quarterly',
      HalfYearly: 'Half yearly',
      Yearly: 'Yearly'
    },
    field,
    newPrice,
    inline
  } = props;
  const radioSelected = Boolean(field && field.value && field.value.length);
  const showPriceNotification = !INTERNATIONAL_FUNNELS.includes(funnel) && radioSelected && newPrice;
  return React.createElement(Stack, {
    space: 2
  }, React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    help: help || HELP_TEXTS[funnel] || HELP_TEXTS.ARHI,
    funnel: funnel,
    width: width,
    optional: optional,
    inline: inline
  }, React.createElement(RadioGroup, {
    options: options
  })), showPriceNotification && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: true
  }, React.createElement(Copy, null, "Your price has been updated to reflect your changed payment frequency. ", React.createElement("strong", null, "$", formatDecimal(newPrice, {
    places: 2,
    separator: ','
  }), "*."))));
};
PaymentFrequency.defaultProps = {
  ...defaultFieldPropTypes,
  options: {
    Weekly: 'Weekly',
    Fortnightly: 'Fortnightly',
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    HalfYearly: 'Half yearly',
    Yearly: 'Yearly'
  }
};
const PaymentFrequencyWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(PaymentFrequency, {
  ...props
}));
export default PaymentFrequencyWithFunnel;